export class AgentServicesList {
}
//# sourceMappingURL=agent-services-list.js.map